// extracted by mini-css-extract-plugin
module.exports = {"normalCardContainer":"_3d2Gg","title":"_1D7ET","buttonContainer":"_3rvey"};